import styled from 'styled-components';

// Styled Components
export const ReviewsContainer = styled.div`
  background: #f8f9fa;
  padding: 40px 0;
  min-height: 100vh;
`;

export const ReviewItem = styled.div`
  background: white;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #dadce0;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
`;

export const ReviewHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
`;

export const UserAvatar = styled.div<{ hasPhoto: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${(props) => (props.hasPhoto ? 'transparent' : '#4285f4')};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 500;
  font-size: 14px;
  flex-shrink: 0;
  overflow: hidden;
`;

export const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
`;

export const UserInfo = styled.div`
  flex: 1;
`;

export const UserName = styled.div`
  color: #1a73e8;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 2px;
`;

export const UserBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #5f6368;
  margin-bottom: 2px;
`;

export const ReviewMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

export const StarRating = styled.div`
  display: flex;
  gap: 1px;
`;

export const Star = styled.span<{ filled: boolean }>`
  color: ${(props) => (props.filled ? '#fbbc04' : '#e8eaed')};
  font-size: 12px;
`;

export const ReviewDate = styled.span`
  color: #5f6368;
  font-size: 12px;
`;

export const NewBadge = styled.span`
  background: #1a73e8;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
`;

export const ReviewText = styled.p`
  color: #3c4043;
  line-height: 1.5;
  margin: 0;
  font-size: 14px;
`;

export const BusinessInfo = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px;
  margin-top: 12px;
  border-left: 3px solid #34a853;
`;

export const BusinessHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 4px;
`;

export const BusinessAvatarContainer = styled.div`
  position: relative;
  flex-shrink: 0;
`;

export const BusinessAvatar = styled.div<{ hasImage: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${(props) => (props.hasImage ? 'transparent' : '#4285f4')};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 10px;
  flex-shrink: 0;
  overflow: hidden;
`;

export const VerifiedBadge = styled.div`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  background: transparent;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const BadgeImage = styled.img`
  width: 100%;
  height: 100%;
  bottom: 0;
  object-fit: cover;
  border-radius: 50%;
`;

export const BusinessAvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
`;

export const BusinessDetails = styled.div`
  flex: 1;
`;

export const BusinessName = styled.div`
  color: #1a73e8;
  font-weight: 500;
  font-size: 13px;
  margin-bottom: 2px;
`;

export const BusinessType = styled.div`
  color: #5f6368;
  font-size: 12px;
  margin-bottom: 4px;
`;

export const BusinessTime = styled.div`
  color: #5f6368;
  font-size: 12px;
`;

export const SectionTitle = styled.h2`
  color: #202124;
  font-weight: 400;
  font-size: 24px;
  margin-bottom: 24px;
  text-align: center;
`;
